module.exports = __webpack_public_path__ + "img/website title.8ea3ac45.png";